import * as signalR from "@microsoft/signalr";
import { API_BASE } from "../config";
import { getVoterId } from "./voterId";

let connection = null;

export async function startConnection(onSessionUpdated) {

    connection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_BASE}/votingHub?voterId=${getVoterId()}`)
        .withAutomaticReconnect()
        .build();

    connection.on("SessionUpdated", session => {
        onSessionUpdated(session);
    });

    await connection.start();

    console.log("Connected to voting hub");
}

export async function sendVote(vnIds) {
    if (!connection) return;

    await connection.invoke("Vote", vnIds);
}